import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";

const marqueeWords = [
  "TRAIN UP A CHILD IN THE WAY THEY SHOULD GO",
  "·",
  "SPIRIT · MIND · BODY",
  "·",
  "YOUNG STEWARDS ARE THE FUTURE",
  "·",
  "PROVERBS 22:6",
  "·",
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0E0E0E] text-[#F4EBDC] relative overflow-hidden"
    >
      {/* Marquee */}
      <div className="bg-[#FFD700] text-[#0E0E0E] py-5 border-y-2 border-[#0E0E0E] overflow-hidden">
        <div className="marquee">
          <div className="marquee__track marquee__track--fast">
            {[...Array(2)].flatMap((_, k) =>
              marqueeWords.map((w, i) => (
                <span
                  key={`${k}-${i}`}
                  className="font-display text-3xl sm:text-4xl tracking-tight"
                >
                  {w}
                </span>
              ))
            )}
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-10 pt-20 pb-10 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <div className="flex items-center gap-4">
            <span className="flex items-center justify-center w-14 h-14 bg-[#1B4F72] border-2 border-[#F4EBDC]">
              <img
                src="/assets/logo/divine-care-logo.png"
                alt="Divine Care"
                className="h-11 w-11 object-contain"
              />
            </span>
            <div className="leading-none">
              <div className="font-display text-3xl text-[#F4EBDC]">
                DIVINE CARE
              </div>
              <div className="font-mono text-[11px] tracking-[0.22em] text-[#FFD700] mt-1">
                ORG · EST. BY FAITH
              </div>
            </div>
          </div>
          <p className="mt-8 max-w-md text-[#F4EBDC]/75 leading-relaxed">
            We raise stewards. Established 2021, Divine Care Organization
            develops young people in spirit, mind, and body — for service,
            leadership, and purpose. Serving LA County, Compton, and Carson.
          </p>
          <p
            className="mt-6 font-mono text-xs tracking-[0.18em] text-[#FFD700]"
            data-testid="footer-scripture"
          >
            “FOR GIVING PRUDENCE TO THOSE WHO ARE SIMPLE, KNOWLEDGE AND
            DISCRETION TO THE YOUNG.” — PROVERBS 1:4
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[11px] tracking-[0.22em] text-[#FFD700]">
            INDEX
          </div>
          <ul className="mt-5 space-y-3 font-display text-2xl">
            <li>
              <Link
                to="/"
                data-testid="footer-link-home"
                className="hover:text-[#FFD700] transition-colors"
              >
                <span className="text-[#FFD700] font-mono text-xs mr-3">01</span>
                HOME
              </Link>
            </li>
            <li>
              <Link
                to="/founder"
                data-testid="footer-link-founder"
                className="hover:text-[#FFD700] transition-colors"
              >
                <span className="text-[#FFD700] font-mono text-xs mr-3">02</span>
                FOUNDER
              </Link>
            </li>
            <li>
              <Link
                to="/basketball-camp"
                data-testid="footer-link-camp"
                className="hover:text-[#FFD700] transition-colors"
              >
                <span className="text-[#FFD700] font-mono text-xs mr-3">03</span>
                BASKETBALL
              </Link>
            </li>
            <li>
              <a
                href="/#contact"
                data-testid="footer-link-contact"
                className="hover:text-[#FFD700] transition-colors"
              >
                <span className="text-[#FFD700] font-mono text-xs mr-3">04</span>
                CONTACT
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[11px] tracking-[0.22em] text-[#FFD700]">
            GIVE US A CALL
          </div>
          <a
            href="tel:+14246107795"
            data-testid="footer-phone"
            className="mt-5 group flex items-center gap-3 font-display text-2xl hover:text-[#FFD700] transition-colors"
          >
            <Phone size={18} className="text-[#FFD700]" />
            424-610-7795
            <ArrowUpRight
              size={16}
              className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
            />
          </a>
          <a
            href="mailto:ydevelopment7@gmail.com"
            data-testid="footer-email"
            className="mt-4 group flex items-center gap-3 font-mono text-sm break-all hover:text-[#FFD700] transition-colors"
          >
            <Mail size={16} className="text-[#FFD700]" />
            ydevelopment7@gmail.com
          </a>

          <div
            data-testid="footer-zelle"
            className="mt-6 border border-[#FFD700]/40 px-3 py-3"
          >
            <p className="font-mono text-[10px] tracking-[0.22em] text-[#FFD700]">
              SUPPORT · ZELLE
            </p>
            <a
              href="mailto:YDevelopment7@gmail.com"
              className="font-mono text-sm break-all text-[#F4EBDC] hover:text-[#FFD700] transition-colors mt-1 block"
            >
              YDevelopment7@gmail.com
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-10 pt-8 pb-2 border-t border-[#F4EBDC]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="font-mono text-[10px] tracking-[0.22em] text-[#F4EBDC]/55 uppercase">
          © {new Date().getFullYear()} Divine Care Organization · All Rights Reserved
        </p>
        <p className="font-mono text-[10px] tracking-[0.22em] text-[#FFD700] uppercase">
          Established 2021 · LA County · Compton · Carson
        </p>
      </div>
    </footer>
  );
};

export default Footer;
